module.exports = __webpack_public_path__ + "img/2_244.3747de2f.png";